// Product search autocomplete — used by reseller store and rate plans pages.
// The load URL on select is configurable via data-product-path on the input
// (e.g. data-product-path="/rate_plans/product?rate_plan_id=42").
// Falls back to the reseller store path when the attribute is absent.
//
// jQuery UI must be loaded separately (via CDN in content_for :javascript) on
// any page that uses this — see reseller_store/index.html.erb for an example.
$(document).ready(function () {
  var $field = $("#product_search_field");
  if (!$field.length) return;

  // Guard: jQuery UI may not have loaded (CDN failure or missing content_for block).
  if (!$.fn.autocomplete) return;

  var rawPath = $field.data("product-path") || "/reseller_store/product";

  // Split the path from any existing query string so the product ID is always
  // inserted before query params, e.g. "/rate_plans/product/123?rate_plan_id=42".
  var pathParts = rawPath.split("?");
  var basePath = pathParts[0];
  var queryString = pathParts[1] ? "?" + pathParts[1] : "";

  var autocompleteWidget = $field.autocomplete({
    minLength: 2,
    source: "/reseller_store/find_product",
    focus: function (event, ui) {
      $field.val(ui.item.extended_description);
      return false;
    },
    select: function (event, ui) {
      $field.val(ui.item.extended_description);
      $("#link_origin_id").val(ui.item.id);
      $("#store_product_div").load(basePath + "/" + ui.item.id + queryString);
      $field.val("");
      return false;
    }
  }).data("ui-autocomplete");

  if (autocompleteWidget) {
    autocompleteWidget._renderItem = function (ul, item) {
      return $("<li>")
        .attr("data-value", item.id)
        .append($("<span>").text(item.extended_description))
        .appendTo(ul);
    };
  }
});

